/** 静态表SvID枚举值 */
export enum SvIds {
  /** 币种表 */
  StaticCoin = 1,
  /** 短信国际代码表 */
  StaticSmsCountry = 2,
  /** 场外币种表 */
  OtcStaticCoin = 3,
  /** 收款账号配置表 */
  OtcStaticPayment = 4,
  /** 场外交易对 */
  OtcStaticSymbol = 5,
  /** 法币表 */
  StaticCurrency = 7,
  /** 渠道类型配置表 */
  StaticChannelType = 8,
  /** 支持语言配置表 */
  StaticLangI18n = 9,
  /** 锁仓配置表 */
  StaticLockConfig = 10,
  /** 物品(资产)表 */
  StaticItemV2 = 13,
  /** 24小时提币额度表 */
  StaticExchangeLimit = 14,
  /** 客户端语言 */
  StaticLangClient = 15,
  /** 分发类型表 */
  StaticDistributeType = 16,
  /** 匿名OTC支付配置表 */
  SotcStaticPayment = 22,
  /** 匿名OTC支付方式与法币关系表 */
  SotcStaticCurrencyPayment = 23,
  /** 匿名otc法币关系交易对 */
  SotcStaticSymbol = 24,
  /** 充提币种静态表 */
  SdwStaticItem = 25,
  /** 换汇交易对表 */
  SwapStaticSymbol = 26,
  /** 资产记录静态配置表 */
  StaticAssetsType = 27,
  /** 币种多链表 */
  StaticCoinTool = 29,
  /** WEB多语言 */
  StaticLangWeb = 31,
  /** 公告类型 */
  StaticArticleType = 34,
  /** 币种权限表 */
  StaticItemPermission = 38,
  /** 系统消息聊天映射表 */
  StaticSystemChatTag = 39,
  /** 商户卖U保卡时长类型 */
  SotcStaticProtectType = 41,
  /** 用户卖U包赔时间类型 */
  SotcStaticGuaranteeType = 42,
  /** 商户营业浮动价格-基本基础类型 */
  SotcStaticFluctuationCondition = 43,
  /** 股票交易对 */
  StockStaticSymbol = 46,
  /** 股票参数配置 */
  StockSymbolConfig = 47,
  /** 杠杆静态数据 */
  MarginStaticSymbol = 48,
  /** 合约静态数据 */
  ContractStaticSymbol = 49,
  /** 股票交易所 */
  StockExchange = 50,
  /** sotc申诉原因配置 */
  SotcComplaintReasonConf = 51,
  /** 币币交易对 */
  StaticSymbol = 55,
  /** 区块地址 */
  StaticChain = 56,
  /** 币币多链配置表 */
  StaticCoinChain = 57,
  /** 币本位合约静态数据 */
  FuturesStaticSymbol = 58,
  /** 返佣类型静态表 */
  StaticRebateType = 59,
  /** U本位跟单配置 */
  CytStaticSetting = 61,
  /** 红包配置 */
  RedPacketSetting = 62,
  /** 匿名OTC数字货币表 */
  SotcStaticItem = 63,
  /** 第三方OTC 支付配置 */
  StaticOtcThirdPayment = 64,
  /** 主业务静态表 */
  StaticBussiness = 66,
  /** H5多语言 */
  StaticLangH5 = 67,
  /** 模拟盘合约静态数据 */
  FcontractStaticSymbol = 73,
  /** 极验证配置数据 */
  MainGeetestCaptchaConfig = 75,
  /** 社交媒体静态表 */
  StaticSocialLink = 76,
  /** APP多语言选择显示顺序 */
  StaticLangDisplayOrder = 77,
  /** 策略表 */
  StaticStrategyConf = 78,
  /** 策略交易对表 */
  StaticStrategySymbol = 79,
  /** 第三方支付配置 */
  StaticOtcThirdPaymentNew = 80,
  /** 第三方支付方式-新 */
  StaticThirdPaymentNew = 81,
  /** 外汇交易对表 */
  FxStaticSymbol = 85,
  /** 新手引导配置 */
  StaticNewbieGuide = 95,
  /** 趣投配置 */
  FunGameConfig = 96,
  /** 过山车配置表 */
  RcConfig = 97,
  /** 爆点配置表 */
  CrashConfig = 98,
  /** vip等级配置 */
  StaticUserVipCreditConfig = 99,
  /** VIP成长值比率配置 */
  StaticUserVipCreditRatioConfig = 100,
  /** VIP手续费配置 */
  StaticUserVipFeeRatioConfig = 101,
  /** 币种AML检测 */
  StaticCoinExchangeAml = 103,
  /** 汇兑支付方式法币地区关联表 */
  ExStaticCurrencyRegionPayment = 104,
  /** 换汇城市表 */
  ExPaymentCity = 105,
  /** 换汇法币静态表 */
  ExStaticCurrency = 106,
}

export enum StorageKeys {
  /** token */
  Token = 'exchange-token',
  /** 设备ID */
  DeviceId = 'exchange-device-id',
  /** 当前法币 */
  CurrentCurrency = 'exchange-current-currency',
  /** 当前语言 */
  CurrentLanguage = 'exchange-current-language',
}
